import { FieldRenderProps } from "react-final-form";
import React from "react";
import ReactJson from "react-json-view";
import { useTheme } from "@material-ui/core";

export interface JsonComponentProps extends FieldRenderProps<any> {
  jsonProps: any;
}

export const JsonComponent = (props: JsonComponentProps) => {
  let val: any = "";
  let error: any = null;

  const theme = useTheme();

  const parseValue = () => {
    try {
      val = JSON.parse(props.input.value);
      if (typeof val === "number") {
        error = "error";
      }
    } catch (e) {
      error = e;
      val = props.input.value;
    }
  };

  if (props.jsonProps && props.jsonProps.parse) {
    parseValue();

    if (typeof val === "boolean") {
      val = props.input.value;
      error = "error";
    }
  } else {
    val = props.input.value;
  }

  const darkTheme = {
    base00: "rgba(0, 0, 0, 0)", // main background
    base01: "rgba(0, 0, 0, 0)",
    base02: "rgb(81, 81, 81)", // tree side borders, Null, NaN, undefined background
    base03: "rgba(0, 0, 0, 0)",
    base04: "rgb(160, 159, 147)", // item count label
    base05: "rgb(211, 208, 200)", // undefined font
    base06: "#fff",
    base07: "#fff", // label font, parenthesis
    base08: "rgb(242, 119, 122)", // NaN font
    base09: "rgb(249, 145, 87)", // strings
    base0A: "rgb(255, 204, 102)", // null font
    base0B: "rgb(249, 145, 87)", // floats
    base0C: "rgb(102, 204, 204)", // indices font
    base0D: "rgb(102, 153, 204)", // show more tree arrow icon
    base0E: "rgb(204, 153, 204)", // booleans
    base0F: "rgb(210, 123, 83)" // integers
  };

  return (
    <div>
      {error ? (
        <>{val}</>
      ) : val ? (
        <ReactJson
          src={val}
          {...props.jsonProps}
          theme={
            theme && theme.palette.type === "dark" ? darkTheme : "rjv-default"
          }
        />
      ) : (
        <></>
      )}
    </div>
  );
};
